
import GroupTitle from "./GroupTitle";
import { InstallmentListType } from "../../../common/types/PaymentTypes";
import { formatCurrency } from "../../../lib/helpers";


type Props = {
    installmentList: Array<InstallmentListType>,
    selectedInstallment: number,
    setSelected: (item: InstallmentListType) => void,
    loading: boolean,
    limitError: string,
    setPaymentAmount: (amount:string)=>void,
    currencySymbol:string
}

const InstallmentListV1 = (props: Props) => {
    const { loading, selectedInstallment, setSelected, installmentList, limitError, setPaymentAmount } = props;

    const onClickInstallmentItem =(item: InstallmentListType)=>{
        setPaymentAmount(formatCurrency(item.totalAmount));
        setSelected(item);
    }

    const CheckIcon = () => (
        <div className="w-4 h-4 relative">
            <div className="w-4 h-4 left-0 top-0 absolute bg-slate-50 rounded-full border border-blue-700" />
            <div className="w-2.5 h-2.5 left-[3px] top-[3px] absolute bg-blue-700 rounded-full" />
        </div>
    )
    const UnCheckIcon = () => (
        <div className="w-4 h-4 rounded-full border border-stone-300" />
    )

    return (
        <div className="w-full mt-6  ">

            <GroupTitle title="Taksit Bilgileri" />

            <div className="mt-4">
                {installmentList.length == 0 && (
                    <div className="text-[#ADA7A7] text-sm text-center">
                        Taksit seçeneklerini görmek için kart bilgilerini doldurunuz.
                    </div>
                )}
                { 
                limitError.length > 0 ? (
                    <div className="text-danger  text-sm text-center">
                        {limitError}
                    </div>
                ) : installmentList?.map((item, index) => {
                    const footerAreaView = (item.extraInstallmentCount > 0 || item.deferralCount > 0);

                    return (
                        <div
                            onClick={() => onClickInstallmentItem(item)}
                            key={index + "installmentList"} 
                            className={`flex items-center cursor-pointer justify-between
                             p-2 border  border-light-border h-[53px] ${index != installmentList.length-1&& "!border-b-0"}`}>
                            <div className={`flex  w-full ${footerAreaView ? "items-start" : "items-center"}`}>
                                <div className={`${footerAreaView && "mt-0.5"}`}>
                                    {item.month == selectedInstallment ? <CheckIcon /> : <UnCheckIcon />}
                                </div>
                                <div className="flex flex-col flex-1 pr-2  ">
                                    <div className="ml-2 flex items-center justify-between w-full">
                                        <label>
                                            {item.month} x {formatCurrency(item.monthlyAmount)}
                                        </label>
                                        <div>
                                            {formatCurrency(item.totalAmount)} {props.currencySymbol}
                                        </div>
                                    </div>
                                    {footerAreaView && (
                                        <div className="flex items-center ml-2 mt-1">
                                            {item.extraInstallmentCount > 0 && (
                                                <div className="p-[3px] mr-2.5 bg-orange-300 rounded ">
                                                    <div className="text-white text-[10px] font-normal">+{item.extraInstallmentCount} TAKSİT</div>
                                                </div>
                                            )}
                                            {item.deferralCount > 0 && (
                                                <div className=" p-[3px] bg-green-400 rounded">
                                                    <div className="text-white text-[10px] font-normal ">{item.deferralCount} AY ERTELEME</div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>


                        </div>
                    )
                })}


            </div>
        </div>
    );
}
export default InstallmentListV1;